﻿import { createFileRoute } from "@tanstack/react-router";
import { ProdutosPage } from "@/paginas/pg_produtos/produtos-main";

export const Route = createFileRoute("/_authenticated/produtos-main")({
  head: () => ({
    meta: [
      { title: "Produtos e receitas — Milky Moo Palmares" },
      { name: "description", content: "Cadastro dos produtos e dos insumos usados em cada um." },
      { property: "og:title", content: "Produtos e receitas — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Cadastro dos produtos e dos insumos usados em cada um.",
      },
    ],
  }),
  component: ProdutosPage,
});
